
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { MainLayout } from '@/components/layouts/MainLayout';
import { createNonLocalizedPageGetServerSideProps } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const SubscriptionTerms = dynamic(async () => await import('@/templates/SubscriptionTerms/SubscriptionTerms'), {
    loading: LoaderScreen,
});
const subscription = () => {
    return (<MainLayout title='Subscription Terms'>
			<SubscriptionTerms />
		</MainLayout>);
};
export default subscription;
const getServerSideProps = createNonLocalizedPageGetServerSideProps('/subscription-terms');

    async function __Next_Translate__getServerSideProps__1a1a20bc41c__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/subscription-terms',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bc41c__ as getServerSideProps }
  